// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LmAK","controls":"styles_controls__1hlv7","charLimit":"styles_charLimit__edhFw","input":"styles_input__3LIV7","send":"styles_send__3qTy1"};